/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-autofocus */
import React, { useRef, useState, useMemo } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { mergeClasses } from '@material-ui/styles';
const useSlotStyles = makeStyles((theme) => ({
    root: {
        cursor: 'text',
        lineHeight: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'Poppins',
    },
    '@keyframes slot': {
        '0%': {
            backgroundColor: theme.palette.primary.main
        },
        '49%': {
            backgroundColor: theme.palette.primary.main
        },
        '50%': {
            backgroundColor: 'transparent'
        },
        '100%': {
            backgroundColor: 'transparent'
        }
    },
    input: {
        width: 48,
        height: 56,
        color: theme.palette.grey[800],
        fontWeight: 500,
        fontSize: 16,
        borderRadius: theme.spacing(1),
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: ({ hasValue }) => {
            if (hasValue)
                return theme.palette.primary.main;
            return theme.palette.grey[100];
        },
    },
    inputAnimBar: {
        width: '2%',
        height: '30%',
        borderColor: ({ hasValue }) => {
            if (hasValue)
                return;
            return 'transparent';
        },
    },
    animatedInput: {
        animation: `$slot 1000ms infinite`,
    },
    password: {
        width: 32,
        height: 32,
        borderRadius: '50%',
        transition: '.4s',
        backgroundColor: ({ hasValue }) => {
            if (hasValue)
                return theme.palette.primary.light;
            return 'transparent';
        },
        [theme.breakpoints.down('sm')]: {
            width: 24,
            height: 24,
        },
    },
    passwordInner: {
        width: 20,
        height: 20,
        borderRadius: '50%',
        transition: '.4s',
        backgroundColor: ({ hasValue }) => {
            if (hasValue)
                return theme.palette.primary.main;
            return theme.palette.grey[100];
        },
        [theme.breakpoints.down('sm')]: {
            width: 12,
            height: 12,
        },
    },
}));
const Slot = ({ variant = 'password', value = '', classes: newClasses = {}, isActive }) => {
    const baseClasses = useSlotStyles({ hasValue: !!value });
    const classes = mergeClasses({ newClasses, baseClasses, Component: Slot });
    return (React.createElement(Grid, { item: true, className: clsx(classes.root, classes[variant]) }, variant === 'password' ? (React.createElement("div", { className: classes.passwordInner })) : ((value === '' ? (React.createElement(Grid, { item: true, className: clsx(classes.inputAnimBar, classes[variant], { [classes.animatedInput]: variant === 'input' && isActive }) })) : (React.createElement(Grid, null, value))))));
};
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        position: 'relative',
        height: 'max-content',
    },
    input: {
        opacity: 0,
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        textAlign: 'center',
        zIndex: -1,
    },
}));
const PinNumberInput = ({ length = 4, variant = 'input', disableKeyboard, classes: newClasses = {}, inputProps = {}, }) => {
    const baseClasses = useStyles();
    const classes = mergeClasses({
        baseClasses,
        newClasses: { root: (newClasses === null || newClasses === void 0 ? void 0 : newClasses.root) || '' },
        Component: PinNumberInput,
    });
    const [value, setValue] = useState('');
    // @ts-ignore
    const ref = useRef();
    const { value: newValue = '', onChange } = inputProps;
    const fieldValue = useMemo(() => newValue ? `${newValue}` : value, [newValue, value]);
    return (React.createElement(Grid, { container: true, direction: 'row', justifyContent: 'space-between', className: classes.root, onClick: () => {
            if (!disableKeyboard) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                ref.current.focus();
            }
        } },
        React.createElement("input", Object.assign({ ref: ref, className: classes.input, type: 'password', value: fieldValue, maxLength: length, onChange: onChange || (({ target: { value: val } }) => setValue(val)), readOnly: disableKeyboard }, inputProps)),
        new Array(length).fill(1).map((_, index) => (React.createElement(Slot, { key: `slot-${index}`, variant: variant, value: fieldValue[index], isActive: index === fieldValue.length, classes: newClasses.slot })))));
};
export default PinNumberInput;
